export const ApiDef_PermissionAPI = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map